<div class="container">
  <h3 class="up-next-title text-white text-uppercase">{{ 'fantasy.up.next.text' | translate }}</h3>
  <p class="font-size-14 mb-0 text-white">{{ 'fantasy.up.next.description' | translate }}</p>

  <div class="up-next-games d-flex flex-column">
    <ng-container *ngIf="upNextGames$ | async as games">
      @for (game of games; track game.GameId) {
        <div class="up-next-game-card d-flex flex-column align-items-center justify-content-center bg-glass">
          <div class="teams-details">
            <div class="home-team">
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0">
                {{ game.HomeTeamName }}
              </p>
              <img class="text-white" src="{{ game.HomeTeamLogo | contentImage: '7' }}" alt="home team image" />
            </div>

            <span class="vs-text font-size-14 fw-bold text-uppercase text-white">
              {{ 'fantasy.game.vs' | translate }}
            </span>

            <div class="away-team">
              <img class="text-white" src="{{ game.AwayTeamLogo | contentImage: '7' }}" alt="away team image" />
              <p class="team-name font-size-14 text-white fw-bold text-capitalize mb-0">
                {{ game.AwayTeamName }}
              </p>
            </div>
          </div>

          <p class="font-size-12 text-white mb-0">{{ game.Time }}, {{ game.Date }}</p>
        </div>
      } @empty {
        <div class="no-items w-100 text-center bg-glass">
          <div class="svg svg-info vs-svg ms-auto me-autoo" fgbAnimateSvg>
            <img class="placeholder-image" [src]="'placeholders/pick-a-player.svg' | contentAssetImage" />
          </div>
          <p class="text-center font-size-14 mb-0 text-white">
            {{ 'pick.player.upcoming.placeholder' | translate }}
          </p>
        </div>
      }
    </ng-container>
  </div>
</div>
